module.exports = __webpack_public_path__ + "img/AF_Tool_Figure_EN.ab5bd81d.png";